angular.module('cfn').directive('cfnSlider', [
  '$rootScope',
  '$log',
  '$timeout',
  '$parse',
  function($rootScope, $log, $timeout, $parse) {
    return {
      restrict: 'E',
      template: '<div></div>',
      replace: true,
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        $log.debug('cfnSlider-link called', element, attrs);
        var settings = {
          theme: 'summer'
        };
        var disabledExpr;

        if (attrs.sliderCfg) {
          var tmp = scope.$eval(attrs.sliderCfg);
          angular.extend(settings, tmp);
        }

        if (attrs.min) settings.min = attrs.min;
        if (attrs.max) settings.max = attrs.max;
        if (attrs.step) settings.step = attrs.step;
        if (attrs.width) settings.width = attrs.width;
        if (attrs.disabled !== undefined) {
          settings.disabled = $parse(attrs.disabled)(scope);
        }
        if (attrs.ngModel) settings.value = attrs.ngModel;

        element.jqxSlider(settings);
        element.on('change', function(event) {
          ngModel.$setViewValue(event.args.value);
          $timeout(function() {
            scope.$apply();
          });
        });

        scope.$watch(attrs.ngModel, function(value) {
          $log.debug('Watch function triggered: ' + value);
          if (value != undefined) {
            element.jqxSlider('setValue', value);
          }
        });

        if (attrs.disabled !== undefined) {
          scope.$watch(attrs.disabled, function(value) {
            $log.debug('Watch (disabled function triggered: ' + value);
            if (value != undefined) {
              element.jqxSlider({
                disabled: value
              });
            }
          });
        }
      }
    };
  }
]);
